import { RemoteGetSectorById } from 'data/usecases';
import { makeApiUrlSectors } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetSectorById = (): RemoteGetSectorById => {
  return new RemoteGetSectorById(makeApiUrlSectors(), makeAxiosHttpClient());
};
